// @ts-check
import {
  wrapFormComponentWithLabelAndError,
  wrapFormComponentWithError,
} from './StyledFormComponentWrappers';
import ProviderSelection from 'shared/components/ProviderSelection';
import connectFormComponentToReduxForm from 'utils/connectFormComponentToReduxForm';

const RawProviderSelection = wrapFormComponentWithLabelAndError(ProviderSelection);
RawProviderSelection.displayName = 'RawProviderSelection';

const ProviderSelectionField = connectFormComponentToReduxForm(RawProviderSelection);
ProviderSelectionField.displayName = 'ProviderSelectionField';

export default ProviderSelectionField;

const ProviderSelectionInput = connectFormComponentToReduxForm(
  wrapFormComponentWithError(ProviderSelection)
);

export { ProviderSelectionInput };
